import { isEmpty, isNumber } from 'lodash-es'
import { JOIN_RULES_PAGE_V2 } from '@/page/member/common/enumsUtil.js'

export const upgradeSwitch = function (upgradePublicityFrequency) {
  // 如果不是一个数字，且小于1，不显示升级弹窗
  if (!isNumber(upgradePublicityFrequency) || upgradePublicityFrequency < 1) return false

  const res = JSON.parse(localStorage?.getItem('upgradeWarnInfo')) || {}

  const upgradeWarnInfo = {
    time: formatDateTime(new Date()), // 第一次进入的日期
    upgradePublicityFrequency: 1, // 已经展示的次数
  }

  // 如果内存内对应的数据，先存数据，再显示升级弹窗
  if (isEmpty(res)) {
    localStorage?.setItem('upgradeWarnInfo', JSON.stringify(upgradeWarnInfo))
    return true
  }

  // 如果内存内有数据
  // 时间差大于1天，先存数据，再显示升级弹窗
  if (formatDateTime(new Date()) > res?.time) {
    localStorage?.setItem('upgradeWarnInfo', JSON.stringify(upgradeWarnInfo))
    return true
  }

  // 时间差小于1天
  // 接口返回的次数小于内存的存取的次数
  if (res?.upgradePublicityFrequency < upgradePublicityFrequency) {
    // 更新内存显示的次数
    res.upgradePublicityFrequency++
    localStorage?.setItem('upgradeWarnInfo', JSON.stringify(res))
    return true
  }

  return false
}

// 将当日时间处理成 20240110形式
const formatDateTime = function (time) {
  const year = time.getFullYear()
  const month = String(time.getMonth() + 1).padStart(2, '0')
  const day = String(time.getDate()).padStart(2, '0')

  const formattedDate = `${year}${month}${day}`

  return Number(formattedDate)
}

// 点击规则详情进入规则页面[这种新容器方式，无法复用status数据]
export const openJoinRules = function () {
  const origin = window?.location?.origin
  const url = origin + JOIN_RULES_PAGE_V2
  window.SodaBridge('openPage', {
    target: 'blank',
    url,
  })
}
// 获取通用参数数据
export const getPageFromParam = function (params) {
  return params?.sourceEntry || params?.fromPoint || '未知'
}

/**
 * 复制 URL 到剪贴板
 */
export async function copyUrl(originUrl) {
  const url = originUrl
  return new Promise(resolve => {
    const node = document.createElement('textarea')
    node.value = url
    document.body.appendChild(node)
    node.select()
    if (document.execCommand('Copy')) {
      document.execCommand('Copy')
      resolve(true)
    } else {
      resolve(false)
    }
    document.body.removeChild(node)
  })
}
